module.exports = __webpack_public_path__ + "img/animation_500_knry3ns4.a772efc2.gif";